import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import Register from '../Register/Register';
import Resetpass from '../Resetpass/Resetpass';
import Select from 'react-select';
//import ReactDOM from "react-dom/client";
import axios from 'axios';
import withNavigateHook from '../../myRoutes';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import banner from '../pics/banner.PNG';
import { useNavigate } from 'react-router-dom'
import About from '../About/About';
//import { set } from 'react-datepicker/dist/dist/date_utils.js';

class Survey extends React.Component {
    constructor(props) {
        super(props);
        this.handleRegisterOpen = React.createRef();
        this.handleResetPassOpen = React.createRef();
        this.handleAboutOpen = React.createRef();
        this.state = {
            fullname: '',
            loginStatus: 'Please complete our survey!',
            area: '',
            token: "",
            name: "",
            userRole: "",
            interested: "",
            laundryweight: "",
            comments: "",
            phonenumber: "",
            customeremail: "",
            customerphonenumber: "",
            preferredservice: "",
            preferreddeliverytime: "",
            customerArea: "",
            servicefrequency: "",
            email: "",
            processStatus: "",
            selectedServiceArea: "",
            selectedPreferredService: "",
            selectedPreferredDeliveryTime: "",
            selectedFrequency: "",
            selectedinterested: "",
            register: "",
            allCustomerRegistrations: []
        };
    }
    loginText = "";

    setAreaChange = (e) => {

        this.setState({ area: e, selectedServiceArea: e.value, customerArea: e });
    }

    serviceAreas = [
        { label: "Blouberg", value: "Blouberg" },
        { label: "Maitland", value: "Maitland" },
        { label: "Milnerton", value: "Milnerton" },
        { label: "Parklands", value: "Parklands" },
        { label: "Sunningdale", value: "Sunningdale" },
        { label: "Other", value: "Other" }
    ]

    setPreferredDeliveryChange = (e) => {
        this.setState({ preferreddeliverytime: e, selectedDeliveryTime: e.value });
    }

    deliveryTimes = [
        { label: "Same Day", value: "Same Day" },
        { label: "Next Day", value: "Next Day" },
        { label: "Weekend", value: "Weekend" },
        { label: "Flexible Day", value: "Flexible Day" }
    ]

    setPreferredServiceChange = (e) => {

        this.setState({ preferredservice: e, selectedService: e.value });
    }

    services = [
        { label: "Wash & Dry only", value: "Wash & Dry only" },
        { label: "Wash, Dry & Iron", value: "Wash, Dry & Iron" },
        { label: "Dry Clean", value: "Dry Clean" },
    ]

    setLaundryWeightsChange = (e) => {

        this.setState({ laundryweight: e, selectedLaundryWeight: e.value });
    }

    clothingWeights = [
        { label: "5-10Kgs", value: "5-10Kgs" },
        { label: "10-20Kgs", value: "10-20Kgs" },
        { label: "20-30Kgs", value: "20-30Kgs" },
        { label: "30-40Kgs", value: "30-40Kgs" },
        { label: "40-50Kgs", value: "40-50Kgs" },
        { label: "50+Kgs", value: "50+Kgs" }
    ]

    setInterestedChange = (e) => {

        this.setState({ interested: e, selectedinterested: e.value });
    }

    servicefrequency = [
        { label: "Weekly", value: "Weekly" },
        { label: "Bi-weekly", value: "Bi-weekly" },
        { label: "Monthly", value: "Monthly" },
    ]
    setFrequencyChange = (e) => {

        this.setState({ servicefrequency: e, selectedFrequency: e.value });
    }

    serviceInterested = [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" },
    ]

    getAllCustomerRegistrations = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry" }
        }
        // const url = "http://localhost/iwash-php/api/allCustomerRegistrations.php";
        const url = "https://testmembership.bktsystems.com/api/UAT_allCustomerRegistrations.php";
        // const url = "https://testmembership.bktsystems.com/api/allCustomerRegistrations.php";
        const response = await axios.get(url, config);
        this.setState({ allCustomerRegistrations: response.data });
    }

    componentDidMount = async () => {
        this.getAllCustomerRegistrations();
    }


    onSubmitSurvey = async (e) => {
        e.preventDefault();
        if (this.state.email === "" || this.state.phonenumber === "" || this.state.fullname === "" || this.state.interested === "") {
            alert("Please fill in all required fields before submitting the survey.");
            return;
        }
        if (this.state.interested === "Yes") {
            if (this.state.area === "" || this.state.laundryweight === "" || this.state.preferredservice === "" || this.state.preferreddeliverytime === "" || this.state.servicefrequency === "") {
                alert("Please fill in all required fields before submitting the survey.");
                return;
            }
            else {
                let config = {
                    headers: { 'Accept': 'application/json' },
                    params: {
                        "db": "iwash_laundry", email: this.state.email, fullname: this.state.fullname, phonenumber: this.state.phonenumber,
                        interested: this.state.interested, comments: this.state.comments, area: this.state.area, servicefrequency: this.state.servicefrequency,
                        laundryweight: this.state.laundryweight, preferredservice: this.state.preferredservice, preferreddeliverytime: this.state.preferreddeliverytime
                    }
                };
                // const url = "http://localhost/iwash-php/api/submitSurvey.php";
                const url = "https://testmembership.bktsystems.com/api/UAT_submitSurvey.php";
                // const url = "https://testmembership.bktsystems.com/api/UAT_submitSurvey.php";
                const response = await axios.get(url, config);
                if (response.status === 200) {
                    if (response.data.includes("Survey successful")) {
                        this.setState({
                            processStatus: ""
                        });
                        if (this.state.allCustomerRegistrations.length > 0) {
                            var emailExists = this.state.allCustomerRegistrations.some(item => item.emailaddress === this.state.email);
                            if (emailExists) {
                                document.getElementById("btnSubmit").style.display = "none";
                                document.getElementById("userExists").style.display = "block";
                                return;
                            }
                            else {
                                document.getElementById("btnSubmit").style.display = "none";
                                document.getElementById("successInterestfeedback").style.display = "block";
                                document.getElementById("signup").style.display = "block";
                                document.getElementById("close").style.display = "none";
                            }
                        }
                    }
                    else {
                        this.setState({
                            processStatus: "Error"
                        });
                        document.getElementById("btnSubmit").style.display = "none";
                        document.getElementById("errorfeedback").style.display = "block";
                        document.getElementById("close").style.display = "block";
                    }
                }
                this.setState({
                    email: "", fullname: "", phonenumber: "", interested: "", comments: "", area: "", servicefrequency: "",
                    laundryweight: "", preferredservice: "", preferreddeliverytime: "", selectedinterested: "", selectedPreferredDeliveryTime: "",
                    selectedPreferredService: "", selectedServiceArea: "", selectedFrequency: ""
                });
                //console.log(response.data);
            }

        } else {
            if (this.state.comments === "" && this.state.interested === "No") {
                alert("Please share your thoughts/comments before submitting the survey.");
                return;
            }
            else {
                let config = {
                    headers: { 'Accept': 'application/json' },
                    params: {
                        "db": "iwash_laundry", email: this.state.email, fullname: this.state.fullname, phonenumber: this.state.phonenumber,
                        interested: this.state.interested, comments: this.state.comments
                    }

                }
                //  const url = "http://localhost/iwash-php/api/submitSurvey.php";
                const url = "https://testmembership.bktsystems.com/api/UAT_submitSurvey.php";
                //const url = "https://testmembership.bktsystems.com/api/submitSurvey.php";
                const response = await axios.get(url, config);
                if (response.status === 200) {
                    if (response.data.includes("Survey successful")) {
                        document.getElementById("btnSubmit").style.display = "none";
                        document.getElementById("successNoInterestfeedback").style.display = "block";
                        document.getElementById("close").style.display = "block";
                    }
                    else {
                        this.setState({
                            processStatus: "Error"
                        });
                        document.getElementById("btnSubmit").style.display = "none";
                        document.getElementById("errorfeedback").style.display = "block";
                        document.getElementById("close").style.display = "block";
                    }
                }
                this.setState({
                    email: "", fullname: "", phonenumber: "", interested: "", comments: "", area: "", servicefrequency: "",
                    laundryweight: "", preferredservice: "", preferreddeliverytime: "", selectedinterested: ""
                });
                // console.log(response.data);
            }
            this.getAllCustomerRegistrations();
        }

    }

    handleCommentsChange = (e) => {
        // console.log(e.target.value);
        this.setState({
            comments: e.target.value

        });
    }

    handleEmailChange = (e) => {
        this.setState({
            email: e.target.value, customeremail: e.target.value
        });
    };

    capitalizeWords = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    handleFullnameChange = (e) => {
        this.setState({
            fullname: this.capitalizeWords(e.target.value), customerfullname: this.capitalizeWords(e.target.value)
        });
    };
    handlePhonenumberChange = (e) => {
        this.setState({
            phonenumber: e.target.value, customerphonenumber: e.target.value
        });
    };
    openResetpass = () => {
        this.setState({ resetpass: "resetpass" });
        this.handleResetPassOpen.current.handleResetPassOpen();
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    openRegister = () => {
        this.setState({ register: "register" });
        document.getElementById("successInterestfeedback").style.display = "none";
        this.handleRegisterOpen.current.handleRegisterOpen();
    }

    onRegisterClose = () => {
        this.setState({ register: "", customeremail: "", customerphonenumber: "", customerfullname: "" });
        document.getElementById('signup').style.display = "none";
        document.getElementById("btnSubmit").style.display = "none";
        this.props.navigate('/', {
            setate: {
            }
        });

    }
    onResetPassClose = () => {
        this.setState({ resetpass: "", resetemail: "", newpassword: "" });
    }

    goToLogin = () => {
        this.props.navigate('/', {
        });
    }

    closeSurvey = () => {
        if (this.state.processStatus === "Error") {
            document.getElementById("errorfeedback").style.display = "none";
            document.getElementById("close").style.display = "none";
            document.getElementById("btnSubmit").style.display = "block";
            this.props.navigate('/survey', {

            });
        }
        else {
            document.getElementById("successNoInterestfeedback").style.display = "none";
            document.getElementById("successInterestfeedback").style.display = "none";
            document.getElementById("close").style.display = "none";
            document.getElementById("signup").style.display = "block";
            document.getElementById("btnSubmit").style.display = "none";
            this.setState({
                email: "", fullname: "", phonenumber: "", interested: "", comments: "", area: "", servicefrequency: "",
                laundryweight: "", preferredservice: "", preferreddeliverytime: "", selectedinterested: "", selectedPreferredDeliveryTime: "",
                selectedPreferredService: "", selectedServiceArea: "", selectedFrequency: ""
            });
            this.props.navigate('/', {

            });
        }

    }
    customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px',
            borderBottom: "2px solid darkblue"
        })
    }

    render() {
        return (
            <>
                <div style={{
                    height: "100%", margin: "5px", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily: "lora",
                    justifyContent: "center", alignItems: "center", paddingTop: "0.5vh", border: '2px solid #f0eee4', borderRadius: "10px", paddingBottom: "25px"
                }}>
                    <div
                        style={{
                            paddingTop: "2vh", border: '3px solid white', borderRadius: "10px",
                            backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                        }}>
                        <div style={{
                            textAlign: "center", fontStyle: "italic", color: "darkblue", fontSize: "25px", fontWeight: "bold", textShadow: "1px 1px 2px white",
                            paddingTop: "30vh"
                        }}>
                            {(() => {
                                if (this.loginText === '') {
                                    return (<label><h4>iWash Laundry  | {this.state.loginStatus}</h4></label>);
                                }
                                if (this.loginText === 'Not found') {
                                    return (<label><h4>iWash Laundry</h4><span style={{ color: "red" }}>{this.state.loginStatus}</span></label>);
                                }
                            }
                            )()}
                        </div>
                    </div>
                    <div className="login-form" style={{ paddingTop: "9vh", color: "darkblue", fontSize: "18px" }}>
                        <Form onSubmit={this.onSubmitSurvey}>
                            <FormGroup>
                                <Input
                                    id="email"
                                    name="email"
                                    underlinecolor="red"
                                    placeholder="Please enter your e-mail address"
                                    onChange={this.handleEmailChange}
                                    type="email"
                                    required={true}
                                    value={this.state.email}
                                    style={{
                                        //backgroundColor:"red",                                
                                        height: "50px",
                                        borderBottom: "2px solid darkblue",
                                    }}
                                />

                            </FormGroup>
                            <FormGroup>
                                <Input
                                    id="phonenumber"
                                    name="phonenumber"
                                    underlinecolor="red"
                                    placeholder="Please enter your phone number"
                                    onChange={this.handlePhonenumberChange}
                                    type="number"
                                    required={true}
                                    value={this.state.phonenumber}
                                    style={{
                                        //backgroundColor:"red",                                
                                        height: "50px",
                                        borderBottom: "2px solid darkblue",
                                    }}
                                    minLength={10}
                                    maxLength={10}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    style={{
                                        //backgroundColor:"red",                                
                                        height: "50px",
                                        borderBottom: "2px solid darkblue",
                                    }}
                                    id="fullname"
                                    name="fullname"
                                    placeholder="Please enter your full name"
                                    value={this.state.fullname}
                                    onChange={this.handleFullnameChange}
                                    type="text"
                                    required={true}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for='serviceinterested' style={{ color: "darkblue", fontStyle: "italic" }}>Would you be interested in using our services?</Label>
                                <Select
                                    styles={this.customStyles}
                                    options={this.serviceInterested}
                                    maxMenuHeight="100%"
                                    //   defaultInputValue=""                                                                        
                                    onChange={opt => this.setInterestedChange(opt.label)}
                                    value={this.state.selectedinterested}
                                // styles={this.customStyles}
                                ></Select>
                            </FormGroup>
                            <div id='notinterested' style={{ display: this.state.interested === "No" ? "block" : "none" }}>
                                <FormGroup>
                                    <Label for="comments" style={{ color: "darkblue", fontStyle: "italic" }} >&#128577; Please share your thoughts/comments </Label>
                                    <Input
                                        style={{ borderBottom: "2px solid darkblue" }}
                                        type="textarea"
                                        id="comments"
                                        name="comments"
                                        rows="2"
                                        value={this.state.comments}
                                        onChange={this.handleCommentsChange}
                                    />
                                </FormGroup>
                            </div>
                            <div id='interested' style={{ display: this.state.interested === "Yes" ? "block" : "none" }}>
                                <FormGroup>
                                    <FormGroup>
                                        <Label for='serviceareas' style={{ color: "darkblue", fontStyle: "italic" }}>Please select your area</Label>
                                        <Select
                                            styles={this.customStyles}
                                            options={this.serviceAreas}
                                            maxMenuHeight="100%"
                                            value={this.state.selectedServiceArea}
                                            onChange={opt => this.setAreaChange(opt.label)}
                                        // styles={this.customStyles}
                                        ></Select>
                                    </FormGroup>
                                    <Label for='servicefrequency' style={{ color: "darkblue", fontStyle: "italic" }}>How often would you like to use our services?</Label>
                                    <Select
                                        styles={this.customStyles}
                                        options={this.servicefrequency}
                                        maxMenuHeight="100%"
                                        value={this.state.selectedFrequency}
                                        onChange={opt => this.setFrequencyChange(opt.label)}
                                    // styles={this.customStyles}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='laundryweight' style={{ color: "darkblue", fontStyle: "italic" }}>Please select the weight estimation of your laundry</Label>
                                    <Select
                                        styles={this.customStyles}
                                        options={this.clothingWeights}
                                        maxMenuHeight="100%"
                                        value={this.state.selectedLaundryWeight}
                                        onChange={opt => this.setLaundryWeightsChange(opt.label)}
                                    // styles={this.customStyles}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='services' style={{ color: "darkblue", fontStyle: "italic" }}>Please select your preferred service</Label>
                                    <Select
                                        styles={this.customStyles}
                                        options={this.services}
                                        maxMenuHeight="100%"
                                        value={this.state.selectedService}
                                        onChange={opt => this.setPreferredServiceChange(opt.label)}
                                    // styles={this.customStyles}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='delivery' style={{ color: "darkblue", fontStyle: "italic" }}>Please select your preferred delivery time</Label>
                                    <Select
                                        styles={this.customStyles}
                                        options={this.deliveryTimes}
                                        maxMenuHeight="100%"
                                        value={this.state.selectedDeliveryTime}
                                        onChange={opt => this.setPreferredDeliveryChange(opt.label)}
                                    // styles={this.customStyles}
                                    ></Select>
                                </FormGroup>
                            </div>
                            <div id="btnSubmit">
                                <FormGroup>
                                    <Button style={{ backgroundColor: "rgb(89, 100, 95)", width: "100%", fontWeight: "bold", color: "white", height: "60px" }}
                                        type="submit">Submit</Button>
                                </FormGroup>
                            </div>
                            <div id="successNoInterestfeedback" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold" }}>
                                <FormGroup>
                                    <Label>Thank you for completing our survey! We appreciate your feedback &#128591;</Label>
                                </FormGroup>
                            </div>
                            <div id="successInterestfeedback" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold" }}>
                                <FormGroup>
                                    <Label>Thank you for completing our survey! You may now register for an account.&#128591;</Label>
                                </FormGroup>
                            </div>
                            <div id="errorfeedback" style={{ display: "none", textAlign: "center", color: "red", fontWeight: "bold" }}>
                                <FormGroup>
                                    <Label>Sorry, there was an error submitting your survey. Please try again &#128533;</Label>
                                </FormGroup>
                            </div>
                            <div id="signup" style={{ display: 'none' }} >
                                <FormGroup>
                                    <Button style={{
                                        backgroundColor: "rgb(67, 129, 67)", width: "100%", color: "rgb(208, 247, 228)", border: "none", fontWeight: "bold",
                                        color: "white", height: "60px"
                                    }} text="Register" onClick={() => this.openRegister()}>Sign up here</Button>
                                </FormGroup>
                            </div>
                            <div id="userExists" style={{ display: 'none', textAlign: "center", color: "green", fontWeight: "bold" }} >
                                <FormGroup>
                                    <Label>Thank you for your interest! You already have an account. Please log in &#128533;</Label>
                                    <Button style={{
                                        backgroundColor: "rgb(67, 129, 67)", width: "100%", color: "rgb(208, 247, 228)", border: "none", fontWeight: "bold",
                                        color: "white", height: "60px"
                                    }} text="Login" onClick={() => this.goToLogin()}>Login here</Button>
                                </FormGroup>
                            </div>
                            <div id="close" style={{ display: 'none' }} >
                                <FormGroup>
                                    <Button style={{
                                        width: "100%", border: "none", fontWeight: "bold",
                                        color: "white", height: "60px"
                                    }} text="Close" onClick={() => this.closeSurvey()} color="danger">Close</Button>
                                </FormGroup>
                            </div>
                            <div>
                                <Register
                                    ref={this.handleRegisterOpen}
                                    emailaddress={this.state.customeremail}
                                    mobilePhone={this.state.customerphonenumber}
                                    fullname={this.state.customerfullname}
                                    area={this.state.customerArea}
                                    onRegisterClose={this.onRegisterClose}
                                />
                                <About
                                    ref={this.handleAboutOpen}
                                    onAboutClose={this.onAboutClose}
                                />
                            </div>
                        </Form>
                        <div style={{
                            textAlign: "center", fontSize: "14px", color: "#666", height: "100%", backgroundColor: "#f0eee4", paddingTop: "5px", paddingBottom: "5px",
                            borderRadius: "10px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div className="footer-links">
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" target="_blank" rel="noopener noreferrer" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }
}

export default withNavigateHook(Survey);
